<template>
  <div class="home">
    <div class="swiper">
      <top-swipe></top-swipe>
    </div>
    <div class="top1">
      <top-one-vue></top-one-vue>
    </div>
    <div class="top2">
      <top-two></top-two>
    </div>
    <div class="top3">
      <top-three-vue></top-three-vue>
    </div>
  </div>
</template>

<script>
import TopSwipe from '../../components/home/topSwipe.vue'
import topOneVue from '@/components/home/topOne.vue'
import topTwo from '../../components/home/topTwo.vue'
import topThreeVue from '@/components/home/topThree.vue'
export default {
  name: 'HomeView',
  components: { TopSwipe, topOneVue, topTwo, topThreeVue }
}
</script>

<style lang="scss" scoped>
.home {
  .top2 {
    background: #f7f7f7;
  }
}
</style>
